import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TableHead from '@material-ui/core/es/TableHead/TableHead';
import { inject, observer } from 'mobx-react';

import './TransactionTable.scss';

const styles = (theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 500,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tableHeader: {
    backgroundColor: '#232D4B',
    color: '#fff',
  },
  tableHeaderRow: {
    color: '#fff',
    fontSize: '1.7rem',
  },
  tableRow: {
    fontSize: '1.4rem',
  },
  sent: {
    color: '#e57200',
  },
  withdraw: {
    color: '#232D4B',
  },
});

@observer
class TransactionTable extends React.Component {
  render() {
    const {
      classes,
      transactions,
      isMoneyTransaction,
      forATG,
      atgPres,
      countryName,
      moneyAlert,
      cancelMoneyAlert,
      atgMoneyAlert,
      cancelAtgMoneyAlert,
      buttonAlert,
      atgButtonAlert,
      cancelTo,
      atgCancelTo,
      roleName,
    } = this.props;
    // console.log(atgPres, countryName, roleName);
    return (
      <Paper className={classes.root}>
        <div className={classes.tableWrapper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeader}>
                <TableCell className={classes.tableHeaderRow}>
                  {isMoneyTransaction
                    ? forATG
                      ? 'Countries'
                      : 'With'
                    : 'With'}
                </TableCell>
                <TableCell align="right" className={classes.tableHeaderRow}>
                  Net Commitment ($)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {forATG && atgPres === countryName
                ? Object.keys(transactions)
                    .filter((el) => el !== atgPres)
                    .sort((a, b) => {
                      if (a < b) {
                        return -1;
                      } else {
                        return 1;
                      }
                    })
                    .map((row, index) => {
                      const t_type =
                        parseInt(transactions[row]) >= 0
                          ? ' Sending to '
                          : ' Getting From ';
                      return (
                        <TableRow key={`transaction-${index}-${row}`}>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tableRow}
                          >
                            {isMoneyTransaction
                              ? forATG
                                ? row.split('$')[0] + t_type + row.split('$')[1]
                                : t_type + row
                              : t_type + row}

                            {parseInt(transactions[row]) > 0 &&
                            // (atgPres === countryName || row === countryName) &&
                            forATG &&
                            row.includes('$') === false ? (
                              atgCancelTo !== row ? (
                                <div
                                  className="cancelMoney"
                                  tocountry={row}
                                  onClick={(e) => this.props.atgMoneyAlert(e)}
                                >
                                  cancel ATG commitment
                                </div>
                              ) : (
                                <div style={{ display: 'inline-block' }}>
                                  <div className="cancelMoney">
                                    Are you sure?
                                  </div>
                                  <div
                                    className="cancelMoney"
                                    tocountry={row}
                                    onClick={(e) =>
                                      this.props.cancelATGMoney(e)
                                    }
                                  >
                                    Yes
                                  </div>
                                  <div
                                    className="cancelMoney"
                                    tocountry={row}
                                    onClick={(e) =>
                                      this.props.cancelAtgMoneyAlert(e)
                                    }
                                  >
                                    No
                                  </div>
                                </div>
                              )
                            ) : null}
                            {isMoneyTransaction ? (
                              parseInt(transactions[row]) > 0 &&
                              !forATG &&
                              roleName === 'Prime Minister' ? (
                                cancelTo !== row ? (
                                  <div
                                    className="cancelMoney"
                                    tocountry={row}
                                    onClick={(e) => this.props.moneyAlert(e)}
                                  >
                                    cancel commitment
                                  </div>
                                ) : (
                                  <div style={{ display: 'inline-block' }}>
                                    <div className="cancelMoney">
                                      Are you Sure?
                                    </div>
                                    <div
                                      className="cancelMoney"
                                      tocountry={row}
                                      onClick={(e) => this.props.cancelMoney(e)}
                                    >
                                      Yes
                                    </div>
                                    <div
                                      className="cancelMoney"
                                      tocountry={row}
                                      onClick={(e) =>
                                        this.props.cancelMoneyAlert(e)
                                      }
                                    >
                                      No
                                    </div>
                                  </div>
                                )
                              ) : null
                            ) : null}
                          </TableCell>
                          <TableCell align="right" className={classes.tableRow}>
                            {Math.abs(transactions[row]).toLocaleString()}
                            {/* {transactions[row].toLocaleString()} */}
                          </TableCell>
                        </TableRow>
                      );
                    })
                : Object.keys(transactions)
                    .sort((a, b) => {
                      if (a < b) {
                        return -1;
                      } else {
                        return 1;
                      }
                    })
                    .map((row, index) => {
                      const t_type =
                        parseInt(transactions[row]) >= 0
                          ? ' Sending to '
                          : ' Getting From ';
                      return (
                        <TableRow key={`transaction-${index}-${row}`}>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tableRow}
                          >
                            {isMoneyTransaction
                              ? forATG
                                ? row.split('$')[0] + t_type + row.split('$')[1]
                                : t_type + row
                              : t_type + row}

                            {parseInt(transactions[row]) > 0 &&
                            // (atgPres === countryName || row === countryName) &&
                            forATG &&
                            row.includes('$') === false ? (
                              atgCancelTo !== row ? (
                                <div
                                  className="cancelMoney"
                                  tocountry={row}
                                  onClick={(e) => this.props.atgMoneyAlert(e)}
                                >
                                  cancel ATG commitment
                                </div>
                              ) : (
                                <div style={{ display: 'inline-block' }}>
                                  <div className="cancelMoney">
                                    Are you sure?
                                  </div>
                                  <div
                                    className="cancelMoney"
                                    tocountry={row}
                                    onClick={(e) =>
                                      this.props.cancelATGMoney(e)
                                    }
                                  >
                                    Yes
                                  </div>
                                  <div
                                    className="cancelMoney"
                                    tocountry={row}
                                    onClick={(e) =>
                                      this.props.cancelAtgMoneyAlert(e)
                                    }
                                  >
                                    No
                                  </div>
                                </div>
                              )
                            ) : null}
                            {isMoneyTransaction ? (
                              parseInt(transactions[row]) > 0 &&
                              !forATG &&
                              roleName === 'Prime Minister' ? (
                                cancelTo !== row ? (
                                  <div
                                    className="cancelMoney"
                                    tocountry={row}
                                    onClick={(e) => this.props.moneyAlert(e)}
                                  >
                                    cancel commitment
                                  </div>
                                ) : (
                                  <div style={{ display: 'inline-block' }}>
                                    <div className="cancelMoney">
                                      Are you Sure?
                                    </div>
                                    <div
                                      className="cancelMoney"
                                      tocountry={row}
                                      onClick={(e) => this.props.cancelMoney(e)}
                                    >
                                      Yes
                                    </div>
                                    <div
                                      className="cancelMoney"
                                      tocountry={row}
                                      onClick={(e) =>
                                        this.props.cancelMoneyAlert(e)
                                      }
                                    >
                                      No
                                    </div>
                                  </div>
                                )
                              ) : null
                            ) : null}
                          </TableCell>
                          <TableCell align="right" className={classes.tableRow}>
                            {Math.abs(transactions[row]).toLocaleString()}
                            {/* {transactions[row].toLocaleString()} */}
                          </TableCell>
                        </TableRow>
                      );
                    })}
            </TableBody>
          </Table>
        </div>
      </Paper>
    );
  }
}

TransactionTable.propTypes = {
  classes: PropTypes.object.isRequired,
  transactions: PropTypes.object.isRequired,
  isMoneyTransaction: PropTypes.bool.isRequired,
  forATG: PropTypes.bool.isRequired,
};

export default withStyles(styles)(inject('countries')(TransactionTable));
